/**
 * Keeps the header bag in step with the cart.
 *
 * Anything that adds to the bag without a page load dispatches cart:refresh,
 * and this is what listens. Without it the badge only ever reflects the cart
 * as it was when the page was rendered, so quick add and the wishlist both
 * looked like they had done nothing.
 *
 * The count comes from /cart.js rather than from whatever the caller thinks
 * it added, so a rejected line or a cart changed in another tab still lands
 * on the truth.
 */
(() => {
  const root = () => window.Shopify?.routes?.root || '/';
  let inFlight = null;

  const apply = (count) => {
    document.querySelectorAll('[data-nyl-cart-count]').forEach((badge) => {
      badge.textContent = String(count);
      badge.hidden = count === 0;
    });

    document.querySelectorAll('[data-nyl-cart-count-label]').forEach((label) => {
      const template = count === 1 ? label.dataset.one : label.dataset.other;
      if (template) label.textContent = template.split('[count]').join(String(count));
    });
  };

  const refresh = () => {
    // Several adds in one gesture should still cost one read.
    if (inFlight) return inFlight;
    inFlight = fetch(`${root()}cart.js`, { headers: { Accept: 'application/json' } })
      .then((response) => (response.ok ? response.json() : null))
      .then((cart) => {
        if (cart) apply(cart.item_count);
      })
      .catch(() => {
        /* The badge keeps its last known value rather than lying about zero. */
      })
      .finally(() => {
        inFlight = null;
      });
    return inFlight;
  };

  document.addEventListener('cart:refresh', refresh);

  // Coming back through the history cache can show a stale bag.
  window.addEventListener('pageshow', (event) => {
    if (event.persisted) refresh();
  });
})();
